import type { IEvolution } from "@/interfaces/IEvolution"
import type { IGamme } from "../interfaces/IGamme"
import { BaseService } from "./BaseService"

export default class ProduitService extends BaseService {
  async getGamme(): Promise<IGamme[]> {
    const query = {
      $filter: "codeGamme ne 'NonClassifie'",
      $select: "Libelle,Slogan",
      $expand:
        "Portefeuilles($filter=Categorie eq 'Fonds ouvert';$select=ArticleSFDR,Categorie,ClassificationAMF,Code,CommissionMouvement,Contractuel,Compartiments,DateCreation,Dedie,Depositaire,FormeJuridique,FrequenceValorisation,HorizonInvestissement,Libelle,OrientationGestion,Repartitions,Slogan;$expand=Compartiments($select=Code,Devise,Libelle,DateCreation,DateValorisation,DroitsEntreeNonAcquis,FraisGestionFixes,PerformancesCumulees,PerformancesAnnualisees,PerformancesAnnuelles,SRI,TypePart,ValeurLiquidative),Gestion($select=Id))",
    }

    return this.executeQuery<IGamme[]>(
      "Gamme",
      query,
      "récupération gammes complètes",
    )
  }

  async getCompartimentEvolution(
    codeCompartiment: string,
  ): Promise<IEvolution> {
    const query = {
      $select: "Portefeuilles",
      $expand: `Portefeuilles($select=Compartiments;$expand=Compartiments($select=Evolution;$filter=${this.createEqualFilter("Code", codeCompartiment)}))`,
    }

    const results = await this.executeQuery<IGamme[]>(
      "Gamme",
      query,
      `récupération évolution compartiment ${codeCompartiment}`,
    )

    const evolution = results.flatMap((g) =>
      g.Portefeuilles.flatMap((p) =>
        p.Compartiments.flatMap((c) => c.Evolution),
      ),
    )

    if (!evolution || evolution.length === 0) {
      throw new Error(
        `Évolution non trouvée pour le compartiment ${codeCompartiment}`,
      )
    }

    return evolution[0]
  }
}
